<nb-card [nbSpinner]="loading">
    <nb-card-body class="py-4">
        <div class="row">
            <div class="col-lg-12">
                <div class="row">
                    <div class="col-lg-9 events-months-summary__wrap">
                        <ng-container *ngIf="list?.length">
                            <div class="d-flex align-items-center">
                                <nb-icon icon="calendar-outline"></nb-icon>
                                <p class="events-months-summary__title">{{ "GENERAL.SUMMARY" | translate }}</p>
                            </div>
                            <div class="events-months-summary">
                                <div *ngFor="let month of list">
                                    <button
                                        nbButton
                                        size="tiny"
                                        shape="semi-round"
                                        (click)="scrollTo(month.description)"
                                    >
                                        {{ month.description }}
                                    </button>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                    <div class="col-lg-3">
                        <app-shared-filter [filter]="filters" (onChange)="onFilterChange($event)"></app-shared-filter>
                    </div>
                </div>
            </div>

            <div class="col-lg-12">
                <div class="events">
                    <div *ngFor="let month of list" class="events-months">
                        <div class="d-flex align-items-center" id="refer-{{ month.description }}">
                            <nb-icon icon="calendar-outline"></nb-icon>
                            <p class="events-month__title">{{ month.description }} ({{ month.tournaments.length }})</p>
                        </div>
                        <hr class="divider my-3" />
                        <div class="row">
                            <div class="col-lg-4" *ngFor="let tournament of month.tournaments">
                                <app-tournament-card [tournament]="tournament"></app-tournament-card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <app-no-results *ngIf="!list && statusCode === 0" [hasFilter]="true"></app-no-results>
        </div>
    </nb-card-body>
</nb-card>
